module.exports = __webpack_public_path__ + "img/warning.793dc030.svg";